/**
 * HighbondNavigationService Bridge
 *
 * Simple Feature Flipper Bridge - decorates the existing Angular service
 * to avoid module loading conflicts.
 *
 * Feature Flag: migratedHighbondNavigationService
 */

// Import ES6 modules directly (they're not Angular services)
const backendApi = require("@results/services/apiCall/backendApi").default;
const ApiPath = require("@viz-ui/services/apiPath/apiPathService").default;

// Import TypeScript service
const { HighbondNavigationService } = require("./highbondNavigationService");

// Apply flipper using Angular's config phase
angular.module("highbond.visualizer.navigation").config(function($provide) {
  // Decorate HighbondNavigationService
  $provide.decorator("HighbondNavigationService", function($delegate, $injector) {
    try {
      const AppConfig = $injector.get("AppConfig");
      const $window = $injector.get("$window");

      if (AppConfig.features && AppConfig.features.migratedHighbondNavigationService) {
        // Using TypeScript HighbondNavigationService
        return createTypeScriptHighbondNavigationService(AppConfig, $window);
      }

      // Using Angular HighbondNavigationService
      return $delegate;
    } catch (error) {
      const errorMessage = error && error.message ? error.message : error;
      console.error(
        `❌ Failed to initialize TypeScript HighbondNavigationService: ${errorMessage}. Falling back to Angular implementation.`,
        error
      );
      return $delegate;
    }
  });
});

function createTypeScriptHighbondNavigationService(AppConfig, $window) {
  // Initialize ApiPath with AppConfig if needed
  if (ApiPath && angular.isFunction(ApiPath.initialize)) {
    ApiPath.initialize(AppConfig);
  }

  // Create TypeScript service instance
  const typeScriptServiceInstance = new HighbondNavigationService({
    backendApi,
    ApiPath,
    appConfig: AppConfig,
    windowRef: $window,
  });

  // Create a properly bound service object with all methods
  const typeScriptService = {
    getGlobalNavProps: typeScriptServiceInstance.getGlobalNavProps.bind(typeScriptServiceInstance),
    getGlobalNavPropsSync: typeScriptServiceInstance.getGlobalNavPropsSync.bind(typeScriptServiceInstance),
    clearCache: typeScriptServiceInstance.clearCache.bind(typeScriptServiceInstance),
    isCached: typeScriptServiceInstance.isCached.bind(typeScriptServiceInstance),
    _implementationType: "TypeScript",
    _migrationVersion: "v1.0",
  };

  return typeScriptService;
}

// Debug function
if (typeof window !== "undefined") {
  window.checkHighbondNavigationMigration = function() {
    try {
      const injector = angular.element(document.body).injector();
      const service = injector.get("HighbondNavigationService");

      return {
        serviceType: service._implementationType || "Angular",
        migrationVersion: service._migrationVersion || "N/A",
      };
    } catch (error) {
      console.error("Error checking migration status:", error);
      return null;
    }
  };
}
